import React from 'react';
import './style.scss';

const Button = (props) => {
    return (
        <button
            onClick={props.onClick}
            className={`btn ${props.className ? props.className : ''} ${props.fullWidth ? 'fullWidth' : ''} ${props.color}`}
            key={1}
        >
            {props.children}
        </button>
    );
};

export default Button;